<template>
    <div class="video_popup" :class="{active: isShowPopup}">
        <div class="content">
            <!-- bg music -->
            <audio :src="backgroundAudio" ref="bgAudio" v-if="backgroundAudio && !isHideBGMusic" autoplay loop @play="bgMusicPlay = true" @pause="bgMusicPlay = false"></audio>
            <!-- audio -->
            <div class="audio_wrap" v-if="isShowAudio">
                <audio :src="audio" ref="audio" 
                @timeupdate="audioTimeupdate" 
                @ended="audioPlay = false"
                @play="audioPlay = true"
                @pause="audioPlay = false"></audio>
                <template>
                    <div class="btn" @click="$refs.audio.play()" v-if="!audioPlay"><img src="../assets/images/icon_play.png" alt=""/></div>
                    <div class="btn" @click="$refs.audio.pause()" v-else><img src="../assets/images/icon_pause.png" alt=""/></div>
                </template>
                <div class="progress"><div class="in" :style="{width: audioProgress + '%'}"></div></div>
            </div>
            <!-- video -->
            <div class="video_wrap" v-if="isShowVideo">
                <div class="video">
                    <!-- <video :src="video" ref="video" 
                    @timeupdate="videoTimeupdate" 
                    @ended="videoPlay = false"
                    @play="videoPlay = true"
                    @pause="videoPlay = false"
                    x5-playsinline="" playsinline="" webkit-playsinline=""></video> -->
                    <canvas ref="vCanvas"></canvas>
                </div>
                <div class="btn" @click="aVideo.play()" v-if="!videoPlay"><img src="../assets/images/icon_play.png" alt=""/></div>
                <div class="btn" @click="aVideo.pause()" v-else><img src="../assets/images/icon_pause.png" alt=""/></div>
                <div class="progress"><div class="in" :style="{width: videoProgress + '%'}"></div></div>
            </div>
            <!-- text -->
            <div class="text_wrap" v-if="isShowText">
                <div class="text" v-html="textToHtml"></div>
            </div>
            <!-- menu -->
            <div class="btn_group">
                <div class="item" @click="showAudio" v-if="audio"><img src="../assets/images/icon_volume.png" alt=""/></div>
                <div class="item" @click="showVideo" v-if="video"><img src="../assets/images/icon_show_video.png" alt=""/></div>
                <div class="item" @click="isShowText = !isShowText" v-if="text"><img src="../assets/images/icon_text.png" alt=""/></div>
                <template v-if="backgroundAudio && !isHideBGMusic">
                    <div class="item" @click="$refs.bgAudio.play()" v-if="!bgMusicPlay"><img src="../assets/images/icon_music_off.png" alt=""/></div>
                    <div class="item active" @click="$refs.bgAudio.pause()" v-else><img src="../assets/images/icon_music_on.png" alt=""/></div>
                </template>
            </div>
        </div>
        <!-- right arrow -->
        <div class="arrow" @click="isShowPopup = !isShowPopup"></div>
    </div>
</template>

<script>
import AlphaVideo from '@/assets/js/alpha-video-webgl.js';
import {mapState} from 'vuex';
export default {
    name: "videoPopup",
    props: ['video', 'text', 'audio', 'isHideBGMusic', 'videoWidth', 'videoHeight'],
    data() {
        return {
            isShowAudio: false,
            isShowVideo: false,
            isShowText: false,
            audioPlay: false,
            videoPlay: false,
            videoProgress: 0,
            audioProgress: 0,
            bgMusicPlay: false,
            isShowPopup: true,
            aVideo: null,
        };
    },
    computed: {
        ...mapState(['backgroundAudio']),
        textToHtml(){
            return this.text.replace(/\n/g, '<br/>');
        }
    },
    components: {
        
    },
    mounted() {
        // console.log(AlphaVideo)
    },
    watch: {
        video: {
            handler: function(val) {
                this.isShowVideo = false;
                if(this.aVideo){ 
                    this.aVideo.pause();
                    this.aVideo = null;
                }
                if(val){
                    this.showVideo();
                }
            },
            immediate: true,
        },
        text: {
            handler: function(val) {
                if(!val){
                    this.isShowText = false;
                }
            },
            immediate: true,
        }
    },
    methods: {
        aVideoInit() {
            if (this.aVideo) { 
                this.aVideo = null;
            }
            this.aVideo = new AlphaVideo({
                src: this.video,
                width: this.videoWidth,
                height: this.videoHeight,
                canvas: this.$refs.vCanvas,
            })
            this.aVideo.play();
            this.aVideo.video.addEventListener('timeupdate', this.videoTimeupdate);
            this.aVideo.video.addEventListener('play', ()=>{
                this.videoPlay = true;
            });
            this.aVideo.video.addEventListener('pause', ()=>{
                this.videoPlay = false;
            });
            this.aVideo.video.addEventListener('ended', ()=>{
                this.videoPlay = false;
            });
        },
        playAudio(){
            if(this.audio){
                this.isShowAudio = true;
                this.$nextTick(()=>{
                    this.$refs.audio.play();
                })
            }else{
                this.isShowAudio = false;
            }
        },
        audioTimeupdate(){
            if(!this.$refs.audio){
                return
            }
            let audio = this.$refs.audio;
            this.audioProgress = audio.currentTime / audio.duration * 100;
        },
        videoTimeupdate(){
            if(!this.aVideo){
                return
            }
            let video = this.aVideo.video;
            this.videoProgress = video.currentTime / video.duration * 100;
        },
        showAudio(){
            if(this.isShowAudio){
                this.isShowAudio = false;
                this.$refs.audio.pause();
            }else{
                this.isShowAudio = true;
                this.isShowVideo = false;
                // this.isShowText = false;
                this.$nextTick(()=>{
                    this.$refs.audio.play();
                })
            }
        },
        showVideo() {
            if(this.isShowVideo){
                this.isShowVideo = false;
                // this.$refs.video.pause();
                this.aVideo.pause();
            }else{
                this.isShowAudio = false;
                this.isShowVideo = true;
                // this.isShowText = false;
                this.$nextTick(()=>{
                    // this.$refs.video.play();
                    this.aVideoInit();
                })
            }
        },
        close(){
            if(this.$refs.audio){
                this.isShowAudio = false;
                this.$refs.audio.pause();
            }
            // if(this.$refs.video){
            //     this.isShowVideo = false;
            //     this.$refs.video.pause();
            // }
            if(this.aVideo){
                this.isShowVideo = false;
                this.aVideo.pause();
            }
        }
    },
    destroyed() {},
};
</script>

<style scoped lang="scss">
.video_popup{
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 100;
    background: rgba($color: #000000, $alpha: .8);
    display: flex;
    height: .5rem;
    border-radius: 0 .5rem .5rem 0;
    &.active{
        height: auto;
        border-radius: 0;
        .arrow{
            &::after{
                border-left: none;
                border-right: .1rem solid #fff; 
            }
        }
        .content{
            display: block;
        }
    }
    .content{
        display: none;
    }
    .arrow{
        width: .5rem;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        &::after{
            content: "";
            display: block;
            border-top: .1rem solid transparent;
            border-bottom: .1rem solid transparent;
            border-left: .1rem solid #fff; 
            border-right: none;
        }
    }
    .btn_group{
        display: flex;
        padding: .2rem 0 .2rem .5rem;
        .item{
            width: .4rem;
            margin-right: .1rem;
            cursor: pointer;
            background: rgba($color: #808080, $alpha: .8);
            border-radius: 50%;
            transition: background-color .1s;
            &:hover{
                background: rgba($color: #c5011b, $alpha: .8);
            }
            &:last-child{
                margin-right: 0;
            }
            img{
                border-radius: 50%;
            }
            &.active{
                animation: play 3s linear infinite;
                @keyframes play {
                    0%{
                        transform: rotate(0deg);
                    }
                    100%{
                        transform: rotate(360deg);
                    }
                }
            }
        }
    }
    .progress{
        width: 100%;
        height: .05rem;
        background: rgba($color: #000, $alpha: .5);
        border-radius: .05rem;
        .in{
            width: 0%;
            min-width: .05rem;
            height: 100%;
            border-radius: .05rem;
            background: rgba($color: #fff, $alpha: .8);
        }
    }
    .video_wrap,
    .audio_wrap{
        .btn{
            width: .4rem;
            margin-right: .1rem;
            border-radius: 50%;
            background: rgba($color: #c5011b, $alpha: .8);
            cursor: pointer;
        }
    }
    .video_wrap{
        padding-top: .1rem !important;
        border-top: none !important;
        display: flex;
        align-items: center;
        // .progress{
        //     margin-top: .16rem;
        // }
        canvas,
        video{
            width: 100%;
            display: block;
            // background: #000;
        }
        .video{
            position: absolute;
            left: 0;
            right: -0.5rem;
            bottom: 100%;
            // &:hover{
            //     .btn{
            //         opacity: 1;
            //     }
            // }
        }
        .btn{
            // opacity: 0;
            transition: opacity .3s;
        }
    }
    .audio_wrap{
        display: flex;
        align-items: center;
    }
    .text_wrap{
        .text{
            font-size: .14rem;
            max-height: 2.6rem;
            overflow: hidden;
            overflow-y: auto;
            &::-webkit-scrollbar{
                width: .05rem;
                background: rgba($color: #fff, $alpha: .1);
                border-radius: .05rem;
            }
            &::-webkit-scrollbar-thumb{
                background: rgba($color: #fff, $alpha: .6);
                border-radius: .05rem;
            }
        }
    }
    .audio_wrap,
    .text_wrap,
    .video_wrap{
        border-top: 1px solid rgba($color: #fff, $alpha: .3);
        position: relative;
        padding: .3rem 0 .3rem .5rem;
        width: 2.7rem;
        color: #fff;
        .btn_close{
            width: .3rem;
            height: .3rem;
            border-radius: 50%;
            background: rgba($color: #000000, $alpha: 0.8);
            position: absolute;
            top: 0;
            right: -0.4rem;
            cursor: pointer;
            z-index: 1;
            &::before,
            &::after{
                content: "";
                width: .2rem;
                height: .02rem;
                background: #fff;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%) rotate(45deg);
            }
            &::after{
                transform: translate(-50%, -50%) rotate(-45deg);
            }
        }
    }
    .audio_wrap{
        .btn_close{
            top: 50%;
            transform: translate(0, -50%);
        }
    }
    @media only screen and (max-width: 640px) {
        bottom: .8rem;
        height: .6rem;
        border-radius: 0 .6rem.6rem 0;
        // &.active{
            
        // }
        .arrow{
            width: .6rem;
        }
        .btn_group{
            padding: .2rem 0 .2rem .6rem;
            .item{
                width: .4rem;
                height: .4rem;
            }
        }
        .audio_wrap,
        .text_wrap,
        .video_wrap{
            width: 3.5rem;
            padding-left: .6rem;
        }
        .video_wrap{
            .video{
                .btn{
                    opacity: 1;
                }
            }
        }
        .text_wrap{
            .text{
                font-size: .18rem;
                max-height: 4rem;
            }
        }
    }
}
</style>